import { render, staticRenderFns } from "./Card-Article.vue?vue&type=template&id=bb2b3ff6&"
import script from "./Card-Article.vue?vue&type=script&lang=js&"
export * from "./Card-Article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports